import config from 'services/table/const';
import { formatDate } from 'utilities/common';
import moment from 'moment';

var sw = '';
var ew = '';

var startWeek = moment().startOf('week').add(1, 'day').toDate();
const endWeek = moment(startWeek).endOf('week').toDate();
sw = formatDate(startWeek, 'YYYY-MM-DD');
ew = formatDate(endWeek, 'YYYY-MM-DD');

let table = { ...config };

table.url = '/report/driver/weekly';
table.filter = { start_at: sw, end_at: ew };
table.columns = {
  driver: {
    title: 'Driver',
    sortable: false,
    format_number: false,
    width: 100,
    class: '',
    component: (row) => {
      return (
        <div>
          <div className="text-ellipsis">{row?.driver?.name || '-'}</div>
          <small className="text-ellipsis">{row?.driver?.phone || ''}</small>
        </div>
      );
    },
  },
  vendor: {
    title: 'Vendor',
    sortable: false,
    format_number: false,
    width: 100,
    class: '',
    component: (row) => {
      return (
        <div className="text-ellipsis">{row?.driver?.vendor?.name || '-'}</div>
      );
    },
  },
  hub: {
    title: 'Hub',
    sortable: true,
    format_number: false,
    width: 100,
    class: '',
    component: (row) => {
      return <div className="text-ellipsis">{row?.hub?.name || '-'}</div>;
    },
  },
  shipping_date: {
    title: 'Jadwal Pengiriman',
    sortable: false,
    format_number: false,
    width: 100,
    class: '',
    component: (row) => {
      return (
        <div className="text-ellipsis">
          {formatDate(row?.shipping_date, 'DD/MM/YYYY')}
        </div>
      );
    },
  },
  total_shipment: {
    title: 'Total Shipment',
    sortable: false,
    format_number: false,
    width: 100,
    class: '',
    component: (row) => {
      return <div>{row?.total_shipment}</div>;
    },
  },
  total_manifest: {
    title: 'Total Manifest',
    sortable: true,
    format_number: false,
    width: 100,
    class: '',
    component: (row) => {
      return <div>{row?.total_manifest}</div>;
    },
  },
  total_point: {
    title: 'Total Point',
    sortable: false,
    format_number: false,
    width: 100,
    class: '',
    component: (row) => {
      return <div>{row?.total_point}</div>;
    },
  },
};

export default table;
